<template>
  <el-select
    style="width: 300px; margin-left: 20px"
    v-model="localValue"
    size="size"
    multiple="multiple"
    placeholder="Статус"
    @change="selected"
    filterable
  >
    <el-option
      key="created"
      label="Создана"
      value="created"
    />
    <el-option
      key="recruitment_members"
      label="В процессе формирования участников"
      value="recruitment_members"
    />
    <el-option
      key="started"
      label="В процессе оценки"
      value="started"
    />
    <el-option
      key="finished"
      label="Завершена"
      value="finished"
    />
  </el-select>
</template>

<script>
export default {
  name: "eval-evaluation-status-select",
  props: {
    value: '',
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
  },
  methods: {
    selected(value) {
      if (value === '') {
        value = null;
      }

      this.localValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
</script>

<style scoped>

</style>
